
export const productsData = [
  {
    id: 1,
    name: 'iPad Pro M2',
    description: 'The ultimate iPad experience with the M2 chip. Features a stunning Liquid Retina XDR display, ProMotion technology, and all-day battery life. Perfect for creative professionals and power users.',
    currentPrice: 1099,
    retailers: [
      { name: 'Amazon', price: 1099, url: '#', logo: 'ri-amazon-fill', inStock: true },
      { name: 'Best Buy', price: 1149, url: '#', logo: 'ri-store-2-line', inStock: true },
      { name: 'Walmart', price: 1129, url: '#', logo: 'ri-store-line', inStock: true },
      { name: 'Apple', price: 1199, url: '#', logo: 'ri-apple-fill', inStock: true },
      { name: 'Target', price: 1139, url: '#', logo: 'ri-focus-2-line', inStock: false },
    ],
    lowestPrice: 999,
    highestPrice: 1299,
    averagePrice: 1149,
    image: 'https://readdy.ai/api/search-image?query=Modern%20sleek%20iPad%20Pro%20M2%20tablet%20computer%20with%20advanced%20display%20technology%20showing%20colorful%20screen%20content%2C%20minimalist%20design%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20high-tech%20aesthetic&width=600&height=600&seq=prod1&orientation=squarish',
    gallery: [
      'https://readdy.ai/api/search-image?query=iPad%20Pro%20M2%20tablet%20front%20view%20showing%20stunning%20display%20with%20colorful%20artwork%2C%20thin%20bezels%2C%20premium%20aluminum%20body%2C%20pure%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=prod1g1&orientation=squarish',
      'https://readdy.ai/api/search-image?query=iPad%20Pro%20M2%20tablet%20side%20profile%20view%20showing%20ultra%20thin%20design%2C%20premium%20aluminum%20construction%2C%20pure%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=prod1g2&orientation=squarish',
      'https://readdy.ai/api/search-image?query=iPad%20Pro%20M2%20tablet%20with%20Apple%20Pencil%20stylus%20accessory%2C%20creative%20tools%20setup%2C%20pure%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=prod1g3&orientation=squarish',
    ],
    category: 'Tablets',
    brand: 'Apple',
    priceChange: -8,
    priceHistory: [
      { date: '2024-01-01', price: 1299 },
      { date: '2024-01-15', price: 1249 },
      { date: '2024-02-01', price: 1199 },
      { date: '2024-02-15', price: 1149 },
      { date: '2024-03-01', price: 1099 },
      { date: '2024-03-15', price: 1129 },
      { date: '2024-04-01', price: 1099 },
      { date: '2024-04-15', price: 1049 },
      { date: '2024-05-01', price: 999 },
      { date: '2024-05-15', price: 1049 },
      { date: '2024-06-01', price: 1099 },
    ],
    specs: [
      { label: 'Display', value: '12.9" Liquid Retina XDR' },
      { label: 'Chip', value: 'Apple M2' },
      { label: 'Storage', value: '256GB' },
      { label: 'Battery', value: 'Up to 10 hours' },
      { label: 'Weight', value: '682g' },
    ],
  },
  {
    id: 2,
    name: 'Dyson Supersonic',
    description: 'Revolutionary hair dryer engineered for fast drying and precision styling. Features intelligent heat control to protect hair from extreme heat damage.',
    currentPrice: 429,
    retailers: [
      { name: 'Dyson', price: 429, url: '#', logo: 'ri-store-2-line', inStock: true },
      { name: 'Sephora', price: 449, url: '#', logo: 'ri-heart-line', inStock: true },
      { name: 'Ulta', price: 439, url: '#', logo: 'ri-sparkle-line', inStock: true },
      { name: 'Best Buy', price: 459, url: '#', logo: 'ri-store-2-line', inStock: false },
    ],
    lowestPrice: 349,
    highestPrice: 499,
    averagePrice: 429,
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20Dyson%20Supersonic%20hair%20dryer%20with%20innovative%20bladeless%20design%2C%20premium%20fuchsia%20and%20nickel%20finish%2C%20sleek%20curves%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20high-tech%20beauty%20device&width=600&height=600&seq=prod2&orientation=squarish',
    gallery: [
      'https://readdy.ai/api/search-image?query=Dyson%20Supersonic%20hair%20dryer%20front%20view%20showing%20unique%20hollow%20design%2C%20premium%20materials%2C%20pure%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=prod2g1&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Dyson%20Supersonic%20hair%20dryer%20with%20magnetic%20attachments%20and%20styling%20accessories%2C%20pure%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=prod2g2&orientation=squarish',
    ],
    category: 'Beauty',
    brand: 'Dyson',
    priceChange: -14,
    priceHistory: [
      { date: '2024-01-01', price: 499 },
      { date: '2024-01-15', price: 479 },
      { date: '2024-02-01', price: 449 },
      { date: '2024-02-15', price: 429 },
      { date: '2024-03-01', price: 399 },
      { date: '2024-03-15', price: 349 },
      { date: '2024-04-01', price: 379 },
      { date: '2024-04-15', price: 399 },
      { date: '2024-05-01', price: 429 },
    ],
    specs: [
      { label: 'Motor', value: 'V9 Digital Motor' },
      { label: 'Heat Settings', value: '4 levels' },
      { label: 'Speed Settings', value: '3 levels' },
      { label: 'Cable Length', value: '2.7m' },
    ],
  },
  {
    id: 3,
    name: 'Sony A7 IV Camera',
    description: 'Full-frame mirrorless camera with 33MP sensor, advanced autofocus, and 4K 60p video recording. The perfect hybrid camera for photo and video creators.',
    currentPrice: 2498,
    retailers: [
      { name: 'B&H Photo', price: 2498, url: '#', logo: 'ri-camera-line', inStock: true },
      { name: 'Amazon', price: 2498, url: '#', logo: 'ri-amazon-fill', inStock: true },
      { name: 'Adorama', price: 2499, url: '#', logo: 'ri-camera-2-line', inStock: true },
      { name: 'Best Buy', price: 2599, url: '#', logo: 'ri-store-2-line', inStock: true },
    ],
    lowestPrice: 2298,
    highestPrice: 2799,
    averagePrice: 2549,
    image: 'https://readdy.ai/api/search-image?query=Professional%20Sony%20A7%20IV%20mirrorless%20camera%20with%20full%20frame%20sensor%2C%20black%20magnesium%20alloy%20body%2C%20advanced%20photography%20technology%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20high-tech%20camera%20equipment&width=600&height=600&seq=prod3&orientation=squarish',
    gallery: [
      'https://readdy.ai/api/search-image?query=Sony%20A7%20IV%20camera%20front%20view%20showing%20sensor%20and%20lens%20mount%2C%20professional%20build%20quality%2C%20pure%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=prod3g1&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Sony%20A7%20IV%20camera%20back%20view%20showing%20LCD%20screen%20and%20controls%2C%20ergonomic%20design%2C%20pure%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=prod3g2&orientation=squarish',
    ],
    category: 'Cameras',
    brand: 'Sony',
    priceChange: -5,
    priceHistory: [
      { date: '2024-01-01', price: 2799 },
      { date: '2024-01-15', price: 2699 },
      { date: '2024-02-01', price: 2598 },
      { date: '2024-02-15', price: 2498 },
      { date: '2024-03-01', price: 2398 },
      { date: '2024-03-15', price: 2298 },
      { date: '2024-04-01', price: 2398 },
      { date: '2024-04-15', price: 2498 },
    ],
    specs: [
      { label: 'Sensor', value: '33MP Full-Frame' },
      { label: 'ISO Range', value: '100-51200' },
      { label: 'Video', value: '4K 60fps' },
      { label: 'AF Points', value: '759 points' },
    ],
  },
  {
    id: 4,
    name: 'Vitamix Blender',
    description: 'Professional-grade blender with aircraft-grade stainless steel blades. Perfect for smoothies, soups, nut butters, and more.',
    currentPrice: 549,
    retailers: [
      { name: 'Williams Sonoma', price: 549, url: '#', logo: 'ri-store-2-line', inStock: true },
      { name: 'Amazon', price: 559, url: '#', logo: 'ri-amazon-fill', inStock: true },
      { name: 'Target', price: 569, url: '#', logo: 'ri-focus-2-line', inStock: true },
    ],
    lowestPrice: 449,
    highestPrice: 649,
    averagePrice: 549,
    image: 'https://readdy.ai/api/search-image?query=High-performance%20Vitamix%20professional%20blender%20with%20powerful%20motor%20base%2C%20large%20clear%20container%2C%20modern%20black%20and%20stainless%20steel%20design%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20premium%20kitchen%20appliance&width=600&height=600&seq=prod4&orientation=squarish',
    gallery: [],
    category: 'Kitchen',
    brand: 'Vitamix',
    priceChange: -15,
    priceHistory: [
      { date: '2024-01-01', price: 649 },
      { date: '2024-02-01', price: 599 },
      { date: '2024-03-01', price: 549 },
      { date: '2024-04-01', price: 499 },
      { date: '2024-05-01', price: 449 },
      { date: '2024-06-01', price: 549 },
    ],
    specs: [
      { label: 'Motor', value: '2.2 HP' },
      { label: 'Container', value: '64 oz' },
      { label: 'Programs', value: '5 presets' },
    ],
  },
  {
    id: 5,
    name: 'iPhone 15 Pro',
    description: 'The most advanced iPhone ever with titanium design, A17 Pro chip, and a revolutionary camera system with 5x optical zoom.',
    currentPrice: 999,
    retailers: [
      { name: 'Apple', price: 999, url: '#', logo: 'ri-apple-fill', inStock: true },
      { name: 'Best Buy', price: 999, url: '#', logo: 'ri-store-2-line', inStock: true },
      { name: 'Amazon', price: 1029, url: '#', logo: 'ri-amazon-fill', inStock: true },
      { name: 'Verizon', price: 999, url: '#', logo: 'ri-signal-tower-line', inStock: true },
    ],
    lowestPrice: 899,
    highestPrice: 1199,
    averagePrice: 1049,
    image: 'https://readdy.ai/api/search-image?query=Latest%20iPhone%2015%20Pro%20smartphone%20with%20natural%20titanium%20finish%2C%20advanced%20triple%20camera%20system%2C%20premium%20materials%2C%20sleek%20design%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20cutting-edge%20mobile%20technology&width=600&height=600&seq=prod5&orientation=squarish',
    gallery: [
      'https://readdy.ai/api/search-image?query=iPhone%2015%20Pro%20front%20view%20showing%20dynamic%20island%20and%20super%20retina%20display%2C%20titanium%20frame%2C%20pure%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=prod5g1&orientation=squarish',
      'https://readdy.ai/api/search-image?query=iPhone%2015%20Pro%20back%20view%20showing%20triple%20camera%20system%20with%20titanium%20finish%2C%20pure%20white%20background%2C%20professional%20product%20photography&width=400&height=400&seq=prod5g2&orientation=squarish',
    ],
    category: 'Phones',
    brand: 'Apple',
    priceChange: -17,
    priceHistory: [
      { date: '2024-01-01', price: 1199 },
      { date: '2024-01-15', price: 1149 },
      { date: '2024-02-01', price: 1099 },
      { date: '2024-02-15', price: 1049 },
      { date: '2024-03-01', price: 999 },
      { date: '2024-03-15', price: 949 },
      { date: '2024-04-01', price: 899 },
      { date: '2024-04-15', price: 949 },
      { date: '2024-05-01', price: 999 },
    ],
    specs: [
      { label: 'Display', value: '6.1" Super Retina XDR' },
      { label: 'Chip', value: 'A17 Pro' },
      { label: 'Storage', value: '256GB' },
      { label: 'Camera', value: '48MP Main' },
    ],
  },
  {
    id: 6,
    name: 'LG 27" 4K Monitor',
    description: 'Professional 4K UHD monitor with IPS panel, HDR10 support, and USB-C connectivity. Perfect for creative work and productivity.',
    currentPrice: 799,
    retailers: [
      { name: 'LG', price: 799, url: '#', logo: 'ri-tv-line', inStock: true },
      { name: 'Amazon', price: 849, url: '#', logo: 'ri-amazon-fill', inStock: true },
      { name: 'Newegg', price: 829, url: '#', logo: 'ri-computer-line', inStock: true },
      { name: 'B&H Photo', price: 799, url: '#', logo: 'ri-camera-line', inStock: false },
    ],
    lowestPrice: 599,
    highestPrice: 999,
    averagePrice: 799,
    image: 'https://readdy.ai/api/search-image?query=Ultra-wide%20LG%2027%20inch%204K%20monitor%20display%20with%20thin%20bezels%2C%20modern%20adjustable%20stand%2C%20professional%20grade%20IPS%20screen%20showing%20vibrant%20colors%2C%20sleek%20black%20design%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20computer%20display%20technology&width=600&height=600&seq=prod6&orientation=squarish',
    gallery: [],
    category: 'Monitors',
    brand: 'LG',
    priceChange: -20,
    priceHistory: [
      { date: '2024-01-01', price: 999 },
      { date: '2024-02-01', price: 899 },
      { date: '2024-03-01', price: 799 },
      { date: '2024-04-01', price: 699 },
      { date: '2024-05-01', price: 599 },
      { date: '2024-06-01', price: 699 },
      { date: '2024-07-01', price: 799 },
    ],
    specs: [
      { label: 'Resolution', value: '3840 x 2160' },
      { label: 'Panel', value: 'IPS' },
      { label: 'Refresh Rate', value: '60Hz' },
      { label: 'Response Time', value: '5ms' },
    ],
  },
  {
    id: 7,
    name: 'MacBook Pro M3 Pro',
    description: 'Supercharged by M3 Pro chip with up to 18 hours of battery life. Features a stunning Liquid Retina XDR display and advanced connectivity.',
    currentPrice: 1999,
    retailers: [
      { name: 'Apple', price: 1999, url: '#', logo: 'ri-apple-fill', inStock: true },
      { name: 'Best Buy', price: 1999, url: '#', logo: 'ri-store-2-line', inStock: true },
      { name: 'B&H Photo', price: 1949, url: '#', logo: 'ri-camera-line', inStock: true },
      { name: 'Amazon', price: 2049, url: '#', logo: 'ri-amazon-fill', inStock: true },
    ],
    lowestPrice: 1799,
    highestPrice: 2299,
    averagePrice: 2049,
    image: 'https://readdy.ai/api/search-image?query=MacBook%20Pro%20laptop%20computer%20with%20M3%20Pro%20chip%2C%20space%20gray%20aluminum%20unibody%20finish%2C%20premium%20build%20quality%2C%20thin%20profile%20showing%20keyboard%20and%20display%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20professional%20computing%20device&width=600&height=600&seq=prod7&orientation=squarish',
    gallery: [],
    category: 'Laptops',
    brand: 'Apple',
    priceChange: -13,
    priceHistory: [
      { date: '2024-01-01', price: 2299 },
      { date: '2024-02-01', price: 2199 },
      { date: '2024-03-01', price: 2099 },
      { date: '2024-04-01', price: 1999 },
      { date: '2024-05-01', price: 1899 },
      { date: '2024-06-01', price: 1799 },
      { date: '2024-07-01', price: 1999 },
    ],
    specs: [
      { label: 'Chip', value: 'Apple M3 Pro' },
      { label: 'Memory', value: '18GB' },
      { label: 'Storage', value: '512GB SSD' },
      { label: 'Display', value: '14.2" Liquid Retina XDR' },
    ],
  },
  {
    id: 8,
    name: 'ASUS WiFi 7 Router',
    description: 'Next-generation WiFi 7 router with blazing fast speeds up to 19 Gbps. Features advanced security and whole-home mesh capability.',
    currentPrice: 299,
    retailers: [
      { name: 'ASUS', price: 299, url: '#', logo: 'ri-router-line', inStock: true },
      { name: 'Amazon', price: 319, url: '#', logo: 'ri-amazon-fill', inStock: true },
      { name: 'Newegg', price: 309, url: '#', logo: 'ri-computer-line', inStock: true },
      { name: 'Best Buy', price: 329, url: '#', logo: 'ri-store-2-line', inStock: false },
    ],
    lowestPrice: 199,
    highestPrice: 399,
    averagePrice: 299,
    image: 'https://readdy.ai/api/search-image?query=High-speed%20ASUS%20WiFi%207%20gaming%20router%20with%20multiple%20external%20antennas%2C%20aggressive%20modern%20black%20design%20with%20RGB%20LED%20accents%2C%20advanced%20networking%20technology%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20networking%20equipment&width=600&height=600&seq=prod8&orientation=squarish',
    gallery: [],
    category: 'Networking',
    brand: 'ASUS',
    priceChange: -25,
    priceHistory: [
      { date: '2024-01-01', price: 399 },
      { date: '2024-02-01', price: 349 },
      { date: '2024-03-01', price: 299 },
      { date: '2024-04-01', price: 249 },
      { date: '2024-05-01', price: 199 },
      { date: '2024-06-01', price: 249 },
      { date: '2024-07-01', price: 299 },
    ],
    specs: [
      { label: 'WiFi Standard', value: 'WiFi 7 (802.11be)' },
      { label: 'Speed', value: 'Up to 19 Gbps' },
      { label: 'Bands', value: 'Tri-band' },
      { label: 'Ports', value: '4x 2.5G LAN' },
    ],
  },
];
